import React from "react"
import Tetris from "./scenes/tetris/components/Game"

const IndexPage = () => <Tetris />

export default IndexPage
